import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductListMiniComponent } from './product-list-mini.component';
import { SanitizePipeModule } from '@digistore/ds24-ui/pipes';
import { ProductPriceModule } from '../product-price/product-price.module';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  declarations: [ProductListMiniComponent],
  exports: [ProductListMiniComponent],
  imports: [
    CommonModule,
    SanitizePipeModule,
    ProductPriceModule,
    DirectivesModule,
  ],
})
export class ProductListMiniModule {}
